module.exports = __webpack_public_path__ + "img/loading.83eadc8b.svg";